import { MAP_LAYER_PREVIEW_URL_PARAM } from "@/v2-common/constants"
import config from "@/v2-backoffice-client/config"

/**
 * The v2-console URL of the same environment with the layer force-loaded
 * on the map (even while it is still disabled).
 */
export function getLayerConsolePreviewUrl(featureCode: string) {
  return `${config.consoleAppUrl}/map?${MAP_LAYER_PREVIEW_URL_PARAM}=${encodeURIComponent(featureCode)}`
}
